import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Spinner from "../Spinner";
import {
  IDMerit_Filter_API,
  IDMerit_List_API,
  IDMerit_Search_API,
} from "../../../actions/auth";
import { useDispatch } from "react-redux";
import Pagination from "react-js-pagination";

const IDMerit = () => {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [listReducer, setListReducer] = useState("");
  const [list, setList] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [filterData, setFilterData] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [default_page, setDefault_page] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (searchData) {
      setLoadingData(true);
      dispatch(
        IDMerit_Search_API(
          searchData && searchData.startsWith("0") ? "no data " : searchData,
          activePage,
          default_page ? default_page : 10
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    } else if (filterData) {
      dispatch(
        IDMerit_Filter_API(
          filterData,
          activePage,
          default_page ? default_page : 10
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false); // Stop loading
      });
    } else {
      setLoading(true);
      dispatch(
        IDMerit_List_API(activePage, default_page ? default_page : "10")
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  }, [activePage]);

  const searchList = (e) => {
    const data = e.target.value.trimStart();
    setSearchData(data);
    setFilterData("");
    setActivePage(1);
    if (data) {
      setLoadingData(true);
      dispatch(
        IDMerit_Search_API(
          data && data.startsWith("0") ? "no data " : data,
          activePage,
          default_page ? default_page : 10
        )
      ).then((response) => {
        if (response?.data?.length > 0) {
          setListReducer(response);
          setList(response?.data);
        } else {
          if (e.target.value != "") {
            setList(response?.data);
          }
        }
        setLoadingData(false);
      });
    } else {
      setLoadingData(true);
      dispatch(
        IDMerit_List_API(activePage, default_page ? default_page : "10")
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false);
      });
    }
    setLoadingData(false);
  };

  const handleSearch = () => {
    if (searchData) {
      setLoadingData(true);
      dispatch(
        IDMerit_Search_API(
          searchData && searchData.startsWith("0") ? "no data " : searchData,
          activePage,
          default_page ? default_page : 10
        )
      ).then((response) => {
        setListReducer(response);
        if (response?.data?.length > 0) {
          setList(response?.data);
        } else {
          // setList(response?.data);
          // setList([]);
          if (searchData != "") {
            setList(response?.data);
          }
        }
      });
      setLoadingData(false);
    }
  };

  const total = listReducer?.total;

  // const handlePageChange = (pagenumber) => {
  //   debugger;
  //   if (pagenumber) {
  //     setLoadingData(true);
  //     dispatch(
  //       IDMerit_List_API(pagenumber, default_page ? default_page : 10)
  //     ).then(() => {
  //       setLoadingData(false); // Stop loading
  //     });
  //     setActivePage(pagenumber);
  //   }
  // };
  const handlePageChange = (pagenumber) => {
    debugger;
    if (pagenumber) {
      setLoadingData(true);

      const pageSize = default_page ? default_page : 10;

      // Check if a filter is applied (assuming `filterData` holds the filter state)
      if (filterData) {
        // If filter is applied, call the filter API for the new page
        dispatch(IDMerit_Filter_API(filterData, pagenumber, pageSize)).then(
          (response) => {
            if (response) {
              setListReducer(response);
              setList(response?.data);
            }
            setLoadingData(false); // Stop loading
          }
        );
      } else {
        // If no filter is applied, fetch the full list for the new page
        dispatch(IDMerit_List_API(pagenumber, pageSize)).then((response) => {
          if (response) {
            setListReducer(response);
            setList(response?.data);
          }
          setLoadingData(false); // Stop loading
        });
      }

      setActivePage(pagenumber); // Update the active page state
    }
  };

  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = default_page ? default_page : 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > total) {
      endIndex = total;
    }
    return `Showing ${startIndex} to ${endIndex} of ${total} entries`;
  };

  const filter = (e) => {
    console.log(e.target.value, "filter_Event");
    setActivePage(1);
    setSearchData("");
    setLoadingData(true);
    setFilterData(e.target.value);
    if (e.target.value) {
      setSearchData("");
      dispatch(
        IDMerit_Filter_API(e.target.value, 1, default_page ? default_page : 10)
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false); // Stop loading
      });
    } else {
      setLoadingData(true);
      dispatch(IDMerit_List_API(1, default_page ? default_page : "10")).then(
        (response) => {
          if (response) {
            setListReducer(response);
            setList(response?.data);
          }
          setLoadingData(false);
        }
      );
    }
  };

  const filter2 = (e) => {
    const selectedValue = e.target.value;
    setDefault_page(selectedValue);
    setItemsPerPage(selectedValue);
    setActivePage(1);
    // setLoading(true);
    setFilterData("");
    if (filterData) {
      // setLoading(true);
      dispatch(
        IDMerit_Filter_API(
          filterData,
          activePage,
          selectedValue ? selectedValue : 10
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false); // Stop loading
      });
    } else {
      // setLoading(true);

      dispatch(IDMerit_List_API(1, selectedValue ? selectedValue : "10")).then(
        (response) => {
          if (response) {
            setListReducer(response);
            setList(response?.data);
          }
          setLoading(false);
        }
      );
    }
  };

  // const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'

  // const sortCities = (order) => {
  //   const sortedCities = [...list].sort((a, b) => {
  //     if (a.firstname < b.firstname) return order === "asc" ? -1 : 1;
  //     if (a.firstname > b.firstname) return order === "asc" ? 1 : -1;
  //     if (a.email < b.email) return order === "asc" ? -1 : 1;
  //     if (a.email > b.email) return order === "asc" ? 1 : -1;
  //     if (a.filterData < b.filterData) return order === "asc" ? -1 : 1;
  //     if (a.filterData > b.filterData) return order === "asc" ? 1 : -1;
  //     return 0;
  //   });
  //   setList(sortedCities);
  // };

  // const handleSortChange = () => {
  //   const newOrder = sortOrder === "asc" ? "desc" : "asc";
  //   setSortOrder(newOrder);
  //   sortCities(newOrder);
  // };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSortChange = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedList = [...list].sort((a, b) => {
      if (key === "city") {
        const cityA = a?.radar[0]?.city || "";
        const cityB = b?.radar[0]?.city || "";
        if (cityA < cityB) return direction === "asc" ? -1 : 1;
        if (cityA > cityB) return direction === "asc" ? 1 : -1;
        return 0;
      } else {
        if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
        if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
        return 0;
      }
    });
    setList(sortedList);
  };

  const handleClearSearch = () => {
    if (searchData) {
      setSearchData("");
      setLoading(true);
      dispatch(
        IDMerit_List_API(activePage, default_page ? default_page : "10")
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  };

  return (
    <>
      {/* Code Added by Mansi Vaghela */}
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">IDMerit</h6>
                </div>
                <div className="card-body">
                  <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <div className="row mb-2 ">
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control search-input-new"
                          placeholder="Enter user, email, or phone number to search"
                          value={searchData}
                          onChange={searchList}
                          // onKeyDown={handleSearch}
                        />
                        {searchData.length >= 1 && (
                          <div
                            onClick={handleClearSearch}
                            className="cross-serach-new"
                          >
                            <i className="fa fa-times cursor-pointerr"></i>
                          </div>
                        )}
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          onClick={handleSearch}
                          // onKeyDown={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                      <div className="col-md-2">
                        <select
                          className="form-select w100"
                          id="inlineFormSelectPref"
                          // value={ChangeStatus}
                          onChange={(e) => filter(e)}
                        >
                          <option value="">Select status</option>
                          <option value={"verify"}>Verified</option>
                          <option value={"non-verify"}>Not verified</option>
                        </select>
                      </div>

                      <div className="col-md-3">
                        <select
                          className="form-select w50"
                          id="inlineFormSelectPref"
                          value={default_page}
                          onChange={(e) => filter2(e)}
                        >
                          <option value={""}>Select No of Rows</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="loader-container">
                    <div className="loaderss"></div>
                  </div>
                ) : (
                  <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                    <table className="table radar-table">
                      <thead>
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">
                            Phone Number
                            <i
                              onClick={() => handleSortChange("phone")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>

                          <th scope="col">
                            Email Id
                            <i
                              onClick={() => handleSortChange("email")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">
                            User
                            <i
                              onClick={() => handleSortChange("firstname")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>{" "}
                          </th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingData ? (
                          <div className="overlay">
                            <div className="loader bg-transparent">
                              <Spinner />
                            </div>
                          </div>
                        ) : (
                          <>
                            {list && list?.length > 0 ? (
                              list?.map((e, index) => (
                                <>
                                  <tr>
                                    <td>
                                      {(activePage - 1) * itemsPerPage +
                                        (index + 1)}
                                    </td>
                                    <td>{e.phone ? e.phone : "-"}</td>
                                    <td>{e?.email ? e?.email : "-"}</td>
                                    <td>{e.firstname ? e.firstname : "-"}</td>
                                    <td>
                                      {e?.riskFactor > 75
                                        ? "Not verified"
                                        : "Verified"}
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  <h5
                                    style={{ textAlign: "center" }}
                                    className="mt-3"
                                  >
                                    No results found
                                  </h5>
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                    {list && list?.length > 0 ? (
                      <div className="d-flex justify-content-between mt-3 align-items-center">
                        <ul className="mt-3 ps-0">
                          <p>{calculateRange()}</p>
                        </ul>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsPerPage}
                          totalItemsCount={total}
                          pageRangeDisplayed={10}
                          onChange={
                            total > itemsPerPage ? handlePageChange : null
                          }
                          itemClass="page-item"
                          linkClass={
                            total && total > 0
                              ? "page-link"
                              : "page-link disabled"
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IDMerit;
